import React from 'react'
import { FormCheckbox } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'
import { getMostRecentFieldValue, getNestedSubelementsByType, getPersonGivenName, getPersonName } from '@fs/zion-sls'
import FieldWrapper from '../../../../../components/generic/panels/uiHelpers/FieldWrapper'
import { useR2StateContext } from '../../../../../providers/r2Provider/R2Context'

const SharedHighlightPersonCheckbox = ({ person, fieldValue, disabled, isNewPerson }) => {
  const [t] = useTranslation()
  const r2State = useR2StateContext()
  const newPerson = t('add-highlight-linked-fields.new-person', 'New person')
  const noRelationship = t('add-highlight-linked-fields.no-relationship', 'No relationship')
  const isSelectedPerson =
    r2State.selectedPersonId === person.id || (newPerson && r2State.createdPersonId === person.id)

  const relationshipToHead = getNestedSubelementsByType(person, 'RELATIONSHIP_TO_HEAD')?.[0]

  const personFullName =
    isSelectedPerson && r2State.highlightsFieldInfo.fieldType === 'NAME_SURN'
      ? `${getPersonGivenName(person)} ${fieldValue}`
      : getPersonName({ person })

  let relationshipToHeadValue = getMostRecentFieldValue(relationshipToHead)
  if (!relationshipToHeadValue) relationshipToHeadValue = isNewPerson && isSelectedPerson ? newPerson : noRelationship

  return (
    <FieldWrapper key={person.id}>
      <FormCheckbox
        disabled={isSelectedPerson || disabled}
        checked={isSelectedPerson}
        name={person.id}
        value={person.id}
        label={`${personFullName} ${relationshipToHeadValue ? `(${relationshipToHeadValue})` : ''}`}
      />
    </FieldWrapper>
  )
}

export default SharedHighlightPersonCheckbox
